import {
  DimeCard,
  DimeCardDescription,
  DimeCardHeader,
  DimeCardTitle,
} from '@nudool/design-system';
import { createFileRoute } from '@tanstack/react-router';
import { RouteGuard } from '../../lib/route-guard.js';
import { EventsSectionTabs } from '../../modules/events/events-section-tabs.js';
import { CalTagList } from '../../modules/events/tags/cal-tag-list.js';

export const Route = createFileRoute('/events/tags')({
  component: EventTagsPage,
});

// eslint-disable-next-line react-refresh/only-export-components -- TanStack Router requires co-exporting Route with the component
function EventTagsPage() {
  return (
    <RouteGuard route="/events/tags">
      <DimeCard borderless className="gap-0 py-0">
        <DimeCardHeader className="mb-4 px-0">
          <DimeCardTitle className="flex items-center gap-2 text-base">Events</DimeCardTitle>
          <DimeCardDescription className="text-sm">
            Tags for reporting. Rename, merge duplicates, or retire ones you no longer use.
          </DimeCardDescription>
        </DimeCardHeader>
        <div className="flex flex-col gap-4">
          <EventsSectionTabs active="tags" />
          <CalTagList />
        </div>
      </DimeCard>
    </RouteGuard>
  );
}
